import { render, staticRenderFns } from "./homepage-auth.vue?vue&type=template&id=387d8fca&scoped=true"
import script from "./homepage-auth.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage-auth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homepage-auth.vue?vue&type=style&index=0&id=387d8fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d8fca",
  null
  
)

export default component.exports